export default {
    black: '#000000',
    bittersweetOrange: '#FF7373',
    carrotOrange: '#E67E22',
    vividTangerineOrange: '#FF9B7D',
    orangeRed: '#FF3C00',
    moonYellow: '#F1C40F30',
    white: '#FFFFFF',
    lynchBlue: '#667085',
    cloudBurstBlue: '#344054',
    tangaroaBlue: '#101828',
    prussianBlue: '#050038',
    neonBlue: '#4262FF',
    linkWater: '#D0D5DD',
    magnoliaWhite: '#F9F5FF',
    quartzWhite: '#E9E2F5',
    slateBlueViolet: '#6941C6',
    mediumSlateViolet: '#9E77ED',
    mediumPurpleViolet: '#7F56D9',
    kimberlyViolet: '#5F5C80',
    royalPurpleViolet: '#53389E',
    mauveViolet: '#D6BBFB',
    solitudeBlue: '#F2F4F7',
    vistaWhite: '#FCFCFD',
    greenWhite: '#E4E7EC',
    ghostWhite: '#F9FAFB',
    aquaHaze: '#F0F2FF',
    softPeach: '#F4EBFF',
    waikawaGrey: '#5E6C84',
    geyserGrey: '#CAD0D0',
    jumboGrey: '#898884',
    charcoalGrey: '#484444',
    zirconGrey: '#EDF0F0',
    loganBlue: '#98A2B3',
    gainsboroWhite: '#DDDDDD',
    eclipseGrey: '#3A3A3A',
    dimGrey: '#666666',
    mountainMeadowGreen: '#12B76A',
    watercourseGreen: '#027A48',
    mintCreamWhite: '#ECFDF3',
    shamrockGreen: '#039855'
};
